import { MutableRefObject, useEffect } from "react";

export default function useAutoFocus<T extends HTMLElement>({
    ref, shouldAutoFocus,
}: {
    ref: MutableRefObject<T | null | undefined>
    shouldAutoFocus?: boolean;
}) {
    useEffect(() => {
        let observer: IntersectionObserver;
        if (shouldAutoFocus && ref?.current != null) {
            observer = new IntersectionObserver(entries => {
                if (entries.some(entry => entry.isIntersecting)) {
                    (entries.firstElement.target as HTMLElement).focus();
                }
            });

            observer.observe(ref.current);
        }

        return () => observer?.disconnect();
    }, [shouldAutoFocus, ref]);
}
